/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Shared by the Angular route host and list pages that add expandable children.
 */
import * as _ from 'lodash';
import {OBJECT_TYPE} from '../constants/object-type';
import {AdnListHelperService} from './list-helper.service';

export function columnFinder(ctrl: any, columnField: string, param: string): boolean {
  const columnArray = _.get(ctrl, [columnField], []);
  return _.isArray(columnArray) ? !!_.find(columnArray, (item: any) => {
    return item === param || _.get(item, ['param']) === param || _.get(item, ['label']) === param;
  }) : false;
}

export function getListChildren(
  ctrl: any,
  adnListHelper: AdnListHelperService,
  objectType: any,
  ChildResourceFactory: any
): void {
  const ctrlChildren: any = {};
  ctrl.getChildren = function(item: any) {
    item.showChildren = !item.showChildren;
    if (!ctrlChildren[item.id]) {
      ctrlChildren[item.id] = {};

      const theConfig: any = {moreParams: {}};
      theConfig.moreParams[objectType.apiParam] = item.id;
      theConfig.childCall = true;
      if (objectType.childType) {
        theConfig.baseTable = OBJECT_TYPE[objectType.childType].apiParam;
      }
      adnListHelper.setUpBasicList(ctrlChildren[item.id], ChildResourceFactory, 'full' + _.get(OBJECT_TYPE[objectType.childType], 'type') + 'List', theConfig);
    }
  };
  ctrl.children = ctrlChildren;
}
